import React from 'react';
import PropTypes from 'prop-types';
import { useAlert } from 'hooks/useAlert/useAlert';
import { Icon } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';

const AlertBar = ({ className }) => {
  const { isShowingAlert, text, closeAlert } = useAlert();
  const { t } = useTranslation('Alerts');

  if (!isShowingAlert) return null;

  return (
    <div className={className} data-testid="alert-bar">
      <div className="alert-bar">
        <div className="alert-bar__body">
          <span className="alert-bar__icon">
            <Icon glyph="info" size="2.4rem" />
          </span>
          <span className="alert-bar__text">{t(text)}</span>
        </div>
        <button className="alert-bar__close" onClick={closeAlert}>
          <Icon glyph="close" size="1.6rem" />
        </button>
      </div>
    </div>
  );
};
AlertBar.propTypes = {
  className: PropTypes.string
};
export default AlertBar;
